import { type FC } from 'react';
import { getBillboardAdData } from 'dibs-google-ad-manager/exports/adHelpers.ts';
import { BillboardBannerAd } from 'dibs-google-ad-manager/exports/BillboardBannerAd.ts';
import { type AdBillboardPlacement } from 'dibs-google-ad-manager/exports/types.ts';
import { useServerVarsContext } from '../../global/ServerVarsContext/ServerVarsContext.tsx';

type Props = {
    isMobile?: boolean;
    placement: AdBillboardPlacement;
    className?: string;
};

export const SharedBillboardAd: FC<Props> = ({ isMobile, placement, className }) => {
    const { areDisplayAdsEnabled } = useServerVarsContext();
    if (!areDisplayAdsEnabled || !placement) {
        return null;
    }

    const adWidth = isMobile ? 'mobile' : 'tablet';

    const billboardAdData = getBillboardAdData(placement)?.[adWidth];

    if (!billboardAdData) {
        return null;
    }

    return <BillboardBannerAd {...billboardAdData} lazyLoad className={className} />;
};
